<template>
  <div class="about_wrapper">
    <div class="bg">
      <div class="tabs__light">
        <ul class="tabs__header">
          <li @click="selectTab(1)" :class="{ tab__selected: 1 == selectedIndex }">
            <div class="tab_item">
              <svg id="图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 190.11">
                <title>guanyu</title>
                <rect class="cls-1" width="166.43" height="161.06" rx="27.66" />
                <rect class="cls-2" fill="#fff" x="19.61" y="22.09" width="105.64" height="9.49" rx="4.63" />
                <rect class="cls-2" fill="#fff" x="19.61" y="49.95" width="105.64" height="9.49" rx="4.63" />
                <rect class="cls-2" fill="#fff" x="19.61" y="77.82" width="69.64" height="9.49" rx="4.63" />
                <circle class="cls-3" opacity="0.5" cx="143.59" cy="133.71" r="56.41" />
                <path class="cls-4" fill="#b6c3d0"
                  d="M143.59,82.25A56.41,56.41,0,1,0,200,138.65,56.4,56.4,0,0,0,143.59,82.25Zm0,107.65a51.25,51.25,0,1,1,51.25-51.25A51.25,51.25,0,0,1,143.59,189.9Z"
                  transform="translate(0 -4.94)" />
                <rect class="cls-2" fill="#fff" x="118.83" y="140.36" width="29.22" height="12.12" rx="5.91"
                  transform="translate(142.61 -56.41) rotate(45)" />
                <rect class="cls-2" fill="#fff" x="128.11" y="133.58" width="48.38" height="12.12" rx="5.91"
                  transform="translate(-54.13 143.65) rotate(-45)" />
              </svg>
              <span>关于我们</span>
            </div>
          </li>
          <li @click="selectTab(2)" :class="{ tab__selected: 2 == selectedIndex }">
            <div class="tab_item">
              <svg id="图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 239 190.97">
                <title>zizhi</title>
                <polygon class="cls-1"
                  points="148.54 79.29 132.56 36.46 119.44 36.46 108.11 36.46 92.12 79.29 148.54 79.29" />
                <polygon class="cls-1" points="95.68 36.46 62.49 36.46 36.5 79.29 78.26 79.29 95.68 36.46" />
                <polygon class="cls-1" points="163.47 45.73 170.43 34.69 144.99 36.46 148.54 48.57 163.47 45.73" />
                <polygon class="cls-1" points="38.07 90.54 105.04 174.63 79.62 90.54 38.07 90.54" />
                <polygon class="cls-1" points="154.94 110.72 136.72 171.02 190.88 103.02 180.59 99.34 154.94 110.72" />
                <polygon class="cls-1" points="120.33 190.97 149.87 90.54 90.8 90.54 120.33 190.97" />
                <polygon class="cls-1" points="36.17 79.29 36 80.11 36.5 79.29 36.17 79.29" />
                <image width="239" height="149"
                  xlink:href="data:image.webp;base64,iVBORw0KGgoAAAANSUhEUgAAAO8AAACVCAYAAACwya0eAAAACXBIWXMAAAsSAAALEgHS3X78AAATCklEQVR4Xu3dW2wc53kG4Pf9Z/ZI7lKkREmULEqMIzWNjbQ24hyaC6FoikJ1AOfClw1cFyiCBrbTJAgMB6lhGAUMIWgN28lFUaCJ0JsWSNHGQZCicZAmd40TJVGSJrUT62RaJMXDLsk9zM7M//ZiSUd2JMs2ucud5fcAhA4ghwtxX33/fN8/M5QEY0z2uJt9gjFmMFl4jckoC68xGWXhNSajLLzGZJSF15iMsvAak1EWXmMyysJrTEZZeI3JKAuvMRll4TUmoyy8xmSUhdeYjLLwGpNRFl5jMsrCa0xGWXiNySgLrzEZZeE1JqMsvMZklIXXmIyy8BqTURZeYzLKwmtMRll4jckoC68xGWXhNSajLLzGZJSF15iMsvAak1HhzT7BmEHCMws8+tTd+MxHP8xr//6ho5+S7tu/qx42TXu4thl0m4G9+IE/5lNT73T/fukS7zwwErQaqxTGoOJSmrtSTr9+7ll/4ezzu+YNbeE1g4rTM6fx2ftrFI+7nzXXXNheDJquHE7kknwrUS5BGCZK/Egh18l3Gq2RKOzsn4zSBx99wt/s4MPAwmsGCs8s8OmLT/KFl8rcU0ndL5sMRvbkc6FL8vlExdS5ci7AqPcqgy4vIAZQl8Ny0OzUXy7G7R99dSy9dP7hoX9jW3jNIHhNlf3f5osuqhXCSiUsePlS7N1ISFYSqhqAe7w0HpBjgvISmoSuOPJiHGu2UQjr4/NJ9LXv5v2wB9gaVmbHXFtl7/tI6r53sRiM7JnPVTFS4CjLPvVVhG6cHhOC3xuA+yDsdcSEgCqAgMQqwPOeDsW8okKSxiuVOL18qhUDsPAas41erbJP8bj7eQsuKqUhS2HhQNGXYp+OpGQlgMYBTMrzYOB0AOCkgAkS4xIqJMoAIagGIC+vdkytk2wC6Hw+yPvpmdMa5upry2bTFzc6l60iLcSO5cD7KkKOJwkmSOxz5KSgAwAPSpoksAdEBeAIoIKE0JHy0iqJlyH+jNBZL/w0cP7ii61k5cR6rvPFP/y4H9YRkoXX9NKbOpclNQ6vSTl30MsfcOQkwH1emiAxju4SuQyggO5qMQBAAB5AG8BVCb9yxI+98MPQuV+sNaJX8tWJxn/+Szse1upr4TXbbstVlhgnUFG3ypYAboRWjoATSEAgKEExgTWBs5L/OYEfOMcfMUl/nXPF5Xix0x7W5pWd85ptsxnaB14q86dTB4PmgWZI8YbnsuRmlcU+CROkxslulRVQIJATEABy6J7gUgQ3+1Dq/hoKKAGaAHgI5BEI84JbWUrjlq/EybA2ryy8ZltMz5zmAyc7bvHd46GvNHI+WS0UEpW949hmx9hD+xw4KYcDAA5uNKHGCVXI11ZZSQ7shlYCSBCv2RAJoLt0dgByBEcFTQI6kooLoeNyKK53hrh5ZeE1W8YzC3zgZMfNBT6XXonLrpSrwnMsH2qv4PbD6y1XWXaDSWz84Ya6cQxAFUmOAzrsqGUPrJTI1UIYtl9u++Sekx0/PXN6qJbPFl6zZUefuhvRn/xZMJWulSjt7XgeylGHHXhY0hSJqW2ostfX/UwnICQwKmC/gKMAVgS/EgZcr5TDaCXsDN3s18JrtmR65jQvn/pjBu04SODLLgwnCd3qhROgjoE8KGjvtlTZGyOBQFABwJjEKVJ1ACsJWSfYwBAun+16XrNlH3vXCS4rdQGQ8/AVwe8PiGMAbqVwDMAhgPsAViWUBOUBhBIcAPcW6uwNqRv+EGCZxF4Jt0CckXDUS/vHiuHo9+XDe052HM8sbPn7DQILr9kW5agl5bpvJ9LlBJYFVkVVAYwAKgAK2Z3RdivuNoT2GhvNK+UIVBxxQNBRR8yAOEyG41NiMZqqBkce+/LNjpUJFl6zJZfOP6x//uULWhwd8VDQAdgC0AQUAUoJOGKjwm5TlX0Dr1k+k5zy0jShI4KfrBTc6Gjczt1zsuOmZ0738nX0hYXXbNmRb45pKsz7TrsdBalfg7ACoAawCSAWKPSpUbS5fH7t7NcdgXhIcBNLaVyqVeLw8qm6hdcYAHglGfGdfLHjAq4HxDKBRUk1AU0ACbp7KvoR4NfMfgF0Z7/AtIiDowHHABQ+H+SDrFdfC6/ZskvnH9Y3Gi/5Rq0Tp/ANyS8BnCd5FcAqoIiA7+mC+VrdOh8Am7NfHHbQjCeHqnll4TXb4sg3x7TolDq6FoQVej8HaE7CSvc8mCn7tHRGd0786uwXwH6BRx00VM0rC6/ZFpcfux+3x4FfW0ui1LlVOF4lOE9iiVBDUKzuVUD9CfA1zSsCYwAOemComlcWXrMtdN9+3XrrH6iwJ0pyXk1H1AhdlbDkhVUAEcB+hnfom1cWXrNt/v6ffqArCf0qgihKserBJUBXAdTQ/8YVMOTNKwuv2TaXzj+sZxvwjVonzjnfcPJLjm7nGlfAUDevLLxmWw1U4woY6uaVhddsqwFsXAFD2ryy8JptNYiNK2A4m1cWXrPtrte4csRONq6AIWxeWXjNtntt4ypoOPklL8yRWJBQB9Tue+MKGLrmlYXX9MRvGldpKwaWA2BOwhUASwCa6j5jyPe1+g5Z88rCa3pis3G1zCDyCOpwmHfkLIB5gnUA/R8bdQ1N88rCa3pC9+3X176b97PLUZxL1QzAJUlXHDnnpWUA/R8bbRiW5pWF1/TMZvVtteN2R6g7YmHj3HeJwE6NjYAhaV5ZeE3PXG9sFHDnx0YAhqJ5ZeE1PTWA+527hqB5ZeE1PTWQ+51/I9PNKwuv6bmB2+98jSw3ryy8pucGdL/zpsw2ryy8pucGdb/zqzLavLLwmr4Y2MYVkNnmlYXX9MWAN66ADDavBiq8PLPA6ZnTHKSlidk+N2lcbVbfzeVz3z82Sn4goAhonOSUwFu8x1SHbnw9ahZrlTj87P21gXh/UpsveWfxmccf4QsvlXn81sN88dezOvGOph589InNf1gzBHhmgQ985x/ceiktFEdz+wLouAfeK/D9AH6X0EEAJXSLyo4EZKPrnQhYB/AKgF8A/CG8/7Hgft2CW1x0k61zX11Kd/ppgwNReZ95/BEuXC0EFyaLue+vz+cvTBZzC1cLwTOPP7IjP0DTG69vXElcIbBAaJ7QEsEagFV2g7MjH+p+NAEmAHMSxgjtBznpHKpVpIWl2StuEKrvjj+fd3rmNO+4l+5wmIYH47VCoVwKS9FashQqOrdGfWGInqdquo2rO+6lH0cQjcDXAcwBuARhFEQMsIJu44h+B37qjoAgEUoFNElEAhyJIh2LsdLwlpLcQ3PEgzc7WI/teHgBYLWW53i1EFZCFNJWHBYLpWAtQbpai5Kbfa3JlkvnHxY/8Tn/6YkwXm221woh57zHiyRSLy04YlRgCIhv80HbW3LN/xeeYAJo3YvzgtYC+U7i6aenSng6377xQfpkIMJrdpcj3xzTr+5dSQ4WRpqJxwIBSao7xz0UiqSC1AtuR+LbRUISPIAOiDXvsYiUtTBgdHa+kf7bD5/Tg48+cbPD9NRAhLe6p6NykibtiFGhXErbzVZSppLqnlTd/oUZJpfOP6xjd96VvudDd0cvBmltPJ/rBHC11PsCA5eTJ3MQsYPNVLkQqbyQKs0HiGPvm2HONXP5QnR77P1/f/IbNztEzw1Et/mZxx9xC1cLwY+LI8GYS1zdh/732410/2SUPvjoE/5mX2+y6didd/EzH/1w8P2ruWCyMBLGhTBIOm2WC3nW1+ObfXlPjY3mAADNqKOWd36qjHQpKSeFK6vp176b94PQhxmI8MJGRbsWzyzw6YtP8vk9v8Oxs5dxabK1Y0vl6/lwRXjhpbK+WG7p6YPCIL0nByW8ALo/yCOPfRmXH7sfum//4Lww0w/kmQUM0vbDTRvvR2BAQrtpoMJrdiUL7dtk4TU7hc88/ggfmiMeaJZ44h1NPrc2OCvmP6q+E5unb3/3H8/pwtnngQELsYXX9N30zGnec7Ljoqlq0PTNMEwQlJx3g9KoakYdFeNIzVLBu3Yh3ZesJ3+bdlK8/681SKdzAzEqMrsHzyzwgZMdNxf43ATa5TGmIwhcyYG5ZtRxpYLItN/5cFDgkHivqNVWGARqh7kkiRWNoN2qVSutj/vF9m0Xn0yAJ4ABqcBWeU1fPfP4I26lPpWb81dHmCvto08PeLq9hEYEhpJnPzdn+I0AkE7dixKUCogBtgDU4bCcJ5dcEqy+wL3RIFyQsMkqr+mb7nK5TF9ZyrlSoQr4Q548LuEoiHFCBZKun8nohlbd0AoxiYjgOoAVgHPey0dejfVOo3EHWjw3QJuGLLymr36WS90dIyOFKI3HAByGdILECQCTXig6MujlYtBt1HRBkuBJ+I1KG4FqQKqJWATQdIDzoJdiH+RLOufWBmrHn4XX9M3lU3W+PyoE7ahdDIJgT0IccMQRL007cj+ogqBg+xfNmwfs/rcgwAP0pGJ0n5nUEJQA6IhuDdCipHkvLTihVnKu1UpziT96Qpcf+9Mbfpd+s/CavpieOc0HTpboK0mIIF8U/RjBfV7YR3JCQBVAHqDb1n6QIHAzs/DauFrIS20SEYC6pEWQ85BmQc5CmiUwF3t/FXQ1IN94JVyOf/KVf/U6++fb+OK2xsJr+ubSZIuT8WhYVFoSWZG0p3v9rkro3no1FLRddVcE4AHP7q11UoKxgAhQk+QqoEUC8yJnIc6CmJUwHzotpjFqUNqoraK9MFFPfvLtb6UXzj4/MMEFLLymTz79F+/lL5vPOddRzjmWU7AqoOKIMoAcujd/I7Z4+xtp80JgCYAnEQOIALQANQCsAVgBtEDgCoBZyc8GLpxH6heVy9VrsdbDdhJdSFx85PeO+v95ct5fOj9YwQUsvKZPPnXl2/irQhjEORYCatR7jBGsdqtu9+L7mx3jjWyGlpQn5AXGgCIADQJ1Ly2TbpnQIoCrEuYcMJcCc4G4JBfUV1O/HtZb0csJ4tvjwJ8/96z/zj8+Dzy0nev47WNzXtNz0zOn+Z579wb7/NXSqNKplLrNOX7QC3eRPE5gL6C83sY91a6ptJ6AFxgTiiStg6wDWJIw130uMObQvdn7YhgGy51UywLqbflG2EyiCxuh/fq5Z/0gbod8Pau8pi8OhQ2H9XZehfxoQEykwgSJKoCioLd8t8gbVlr5dZF1AYsOnPcbTShJVwQsBOBKAq3Bo1F0vrXMIJpdTn5Tac8+j2fwNwMd2k0WXtNzl0/VGbbXA4S5ooOvpuBekBMARgHl8VYqriAQIqE3Ci2JWQ/MAn42oJuH16KcWw28mg0E0fJyJ35XWWnt+C3+/Le+lKnQbrJls+mp1y+Z6XRbCvcBEe8jcBzQBIHCGy2Zu1V247eCJ+kBJJDaIBrYGPc4unlAsx6chdKNJlS6SAX1TiFodGqtdmFPlLy7fNxTL/ovfHmPLp1/GBjw5fGNWOU1PXftkhnEhKS9BKoAi+g+oeC6S+ZXl8aQR3c+m4LabEQ1QaxKWHS8ptJudo49F19tQrU60YW17vnsiSnooemPSPft14OPXu+7ZoeF1/TU5VN1riy03WQ1KNKpmnpOkHjDJfNvnc9ujHsEtbq7obBGYEXAgmN33OOvF9rXd443mlA7fb/l7WLLZtMzm9ft+kpSQiF/gPS3CfygF963sZ9577VL5ht2jq8Z9zi6ZWyMe7wwFwBzKTgXyC8pl6+vxvF6FjvHb4dVXtNT1+6qonPV1PsxdB9iXQAYbDzRU8CNO8cAlrww5+g2xj34rXHPOti4XqXNWhPqrbDwmp75rV1VQkXgq7uqCBEghN077tkKC6/pmdfvqoIwRqDSbVQp2LhiIEH3sSK7ctyzFXbOa3ri2hHRSKApwt/mxQ9Iei/JdwIak+A29h7v2nHPVljlNT1zKGy4NAnyRGck9Rrr7qhisduMQsORsaBVCUu7ddyzFRZe0xOXT9V5JXHuUBzlfYiyI0cl5QF0BCwDSCSsgri6m8c9W2HhNdtueuY0cQoYc4lLqDBgsHnRQYvkHIE5QWugFiXMv6mre3bZ+eybYeE1PfGxd51g8IsLKJeIBIgJXwd5GcC8BxoUa15a2u3jnq2w8JqeuKv2f/qv0Qk/6pIOvK/DY5ZALaVPQ8d1iasCdv24Zyus22x64tidd/FjH7o7rFUrJXUao2I4GqVpMOKYNOVajKJWJ1/sNGrdcc/F48f8977ypaHdDdULFl7TK+QnPse/HDsQEut534rCUj5PhEqTVidOivvS28uVXT/u2QoLr+mZzWfvPrdG9552ngBwrtjR2JET+t5XvuQvfvIb9ijXLbDwml7j9MxpuPGvAgA2AgtYld0yC68xGfXmbz9ijBkoFl5jMsrCa0xGWXiNySgLrzEZZeE1JqMsvMZklIXXmIyy8BqTURZeYzLKwmtMRll4jckoC68xGWXhNSajLLzGZJSF15iMsvAak1EWXmMyysJrTEZZeI3JKAuvMRll4TUmoyy8xmSUhdeYjLLwGpNRFl5jMsrCa0xGWXiNySgLrzEZZeE1JqMsvMZk1P8DXwATUI5YVugAAAAASUVORK5CYII=" />
                <polygon opacity="0.5" class="cls-2"
                  points="180.59 11.03 197.71 45.73 236 51.29 208.29 78.3 214.84 116.43 180.59 98.43 146.34 116.43 152.88 78.3 125.18 51.29 163.47 45.73 180.59 11.03" />
                <path class="cls-3"
                  d="M199.92,50.29l-38.29-5.56L144.51,10l-17.12,34.7L89.1,50.29l27.71,27-6.55,38.13,34.25-18,34.25,18L172.22,77.3Zm-26.43,57-29-15.24-29,15.24,5.53-32.27L97.62,52.2,130,47.49l14.49-29.36L159,47.49l32.41,4.71L168,75.06Z"
                  transform="translate(36 1)" />
              </svg>
              <span>资质荣誉</span>
            </div>
          </li>
          <li @click="selectTab(3)" :class="{ tab__selected: 3 == selectedIndex }">
            <div class="tab_item">
              <svg id="图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 193.84">
                <title>xinwen</title>
                <rect class="cls-1" width="186.98" height="181.89" rx="27.66" />
                <rect class="cls-2" fill="#fff" x="22.9" y="119.67" width="75.77" height="10.27" rx="5.14" />
                <rect class="cls-2" fill="#fff" x="22.9" y="144.31" width="75.77" height="10.27" rx="5.14" />
                <path class="cls-2" fill="#fff"
                  d="M92.27,29.09H30.15a6.82,6.82,0,0,0-6.82,6.82V98a6.82,6.82,0,0,0,6.82,6.83H92.27A6.83,6.83,0,0,0,99.1,98V35.91A6.82,6.82,0,0,0,92.27,29.09ZM91.74,97.5h-61v-61H91.74Z"
                  transform="translate(0 -4.16)" />
                <path class="cls-2" fill="#fff"
                  d="M162.9,36.87h-42a6.82,6.82,0,0,0-6.82,6.83V152.15a6.82,6.82,0,0,0,6.82,6.82h42a6.82,6.82,0,0,0,6.82-6.82V43.7A6.82,6.82,0,0,0,162.9,36.87ZM162,151.67H121.82V44.18H162Z"
                  transform="translate(0 -4.16)" />
                <polygon class="cls-3" points="200 193.84 103 193.84 103 74.93 151.5 112.13 200 74.93 200 193.84" />
                <path class="cls-4"
                  d="M151.5,116.3,103,79.1V198h97V79.1Zm42.34,76.45H109.17V91.65l42.33,31.63,42.34-31.63Z"
                  transform="translate(0 -4.16)" />
              </svg>
              <span>新闻动态</span>
            </div>
          </li>
          <li @click="selectTab(4)" :class="{ tab__selected: 4 == selectedIndex }">
            <div class="tab_item">
              <svg id="图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198.22 186.64">
                <title>lainxi</title>
                <path class="cls-1"
                  d="M158.64,28.12H14.54A13.65,13.65,0,0,0,.89,41.77v101a13.65,13.65,0,0,0,13.65,13.65H43.72c.06,9.25.21,36,0,36.9l64.64-36.9h50.3a13.65,13.65,0,0,0,13.65-13.65v-101A13.65,13.65,0,0,0,158.64,28.12ZM43.47,102.38a13,13,0,1,1,13-13A13,13,0,0,1,43.47,102.38Zm42.72,0a13,13,0,1,1,13-13A13,13,0,0,1,86.19,102.38Zm43.68,0a13,13,0,1,1,13-13A13,13,0,0,1,129.87,102.38Z"
                  transform="translate(-0.89 -6.68)" />
                <path class="cls-2" opacity="0.5"
                  d="M190.88,6.68H104a8.24,8.24,0,0,0-8.24,8.23V75.83A8.24,8.24,0,0,0,104,84.07h17.6c0,5.58.13,21.69,0,22.25l39-22.25h30.34a8.24,8.24,0,0,0,8.23-8.24V14.91A8.24,8.24,0,0,0,190.88,6.68Z"
                  transform="translate(-0.89 -6.68)" />
                <path class="cls-3"
                  d="M190.88,6.68H104a8.24,8.24,0,0,0-8.24,8.23V75.83A8.24,8.24,0,0,0,104,84.07h17.6c0,5.58.13,21.69,0,22.25l39-22.25h30.34a8.24,8.24,0,0,0,8.23-8.24V14.91A8.24,8.24,0,0,0,190.88,6.68Zm1.42,65.39a7.15,7.15,0,0,1-7.15,7.14H158.81L125,98.54c.13-.49.05-14.48,0-19.33H109.69a7.14,7.14,0,0,1-7.14-7.14V19.18A7.15,7.15,0,0,1,109.69,12h75.46a7.15,7.15,0,0,1,7.15,7.15Z"
                  transform="translate(-0.89 -6.68)" />
              </svg>
              <span>联系我们</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="about_content">
      <div class="tab about_us" v-show="selectedIndex === 1">
        <div class="intro content_wrapper">
          <p>
            广州磐钴智能科技有限公司是一家以北斗卫星追踪、应急通信、卫星数传相关产品和平台研发的高新科技技术企业。自创立以来,一直坚持“科技、突破、创新、可持续发展”的理念,坚持自主研发创新。目前已登记软件著作权53项、实用新型25项、发明专利11项,已通过ISO9001质量管理体系等相关资质认证,获得省市级专精特新企业、硬科技企业培育百强、种子独角兽企业等称号。
          </p>
          <br>
          <br>
          <p>
            磐钴智能团队在卫星通信应用领域有13年以上的经验,尤其北斗RDSS短报文应用领域有较深的积累,为卫星物联网应用第一梯队,已在卫星物联网领域有良好的客户基础。自建“北斗卫星地面站”和“卫星数据中心”,为广大用户提供“售前咨询+产品规划+硬件产品+APP+平台系统+接收端+现场安装+现场培训+售后服务”的一条龙服务,提供适合客户需求的产品和服务。目前基于窄带卫星物联网自研的“低码率语音压缩算法”和“渐进式图像压缩算法”已逐步形成行业领先。
          </p>
        </div>
        <div class="path">
          <h1>发展历程</h1>
          <div id="timeline-content">
            <ul class="timeline">
              <li class="event" data-date="2024年">
                <p>
                  <span class="month">01月</span>
                  <span class="event-item">旗下多款产品都被评为广东省名优高新技术产品</span>
                </p>
                <p>
                  <span class="month">05月</span>
                  <span class="event-item">广东省北斗规模应用协会第一届理事单位</span>
                </p>
                <p>
                  <span class="month">08月</span>
                  <span class="event-item">发布“星地多网融合调度平台”</span>
                </p>
                <p>
                  <span class="month"></span>
                  <span class="event-item" style="margin-left: 3em;">第八届创客广东智能制造中小企业创新创业大赛企业组优胜奖</span>
                </p>
              </li>
              <li class="event" data-date="2023年">
                <p>
                  <span class="month">07月</span>
                  <span class="event-item">发布“天通哨兵野外图传系统”</span>
                </p>
                <p>
                  <span class="month">09月</span>
                  <span class="event-item">专精特新扶优计划培育企业</span>
                </p>
                <p>
                  <span class="month">11月</span>
                  <span class="event-item">第十二届中国创新创业大赛（广东赛区）暨第十一届“珠江天使杯”科技创新创业大赛成长企业组三等奖</span>
                </p>
                <p>
                  <span class="month"></span>
                  <span class="event-item" style="margin-left: 3em;">第十二届中国创新创业大赛全国赛成长组优秀企业</span>
                </p>
                <p>
                  <span class="month">12月</span>
                  <span class="event-item">北斗相关知识产权超77件</span>
                </p>
              </li>
              <li class="event" data-date="2022年">
                <p>
                  <span class="month">12月</span>
                  <span class="event-item">种子独角兽企业</span>
                </p>
                <p>
                  <span class="month"></span>
                  <span class="event-item" style="margin-left: 3em;">广东省专精特新中小企业</span>
                </p>
                <p>
                  <span class="month"></span>
                  <span class="event-item" style="margin-left: 3em;">硬科技企业培育百强企业</span>
                </p>
              </li>
              <li class="event" data-date="2021年">
                <p>
                  <span class="month">03月</span>
                  <span class="event-item">通过“质量管理体系认证”</span>
                </p>
                <p>
                  <span class="month">04月</span>
                  <span class="event-item">北斗相关知识产权超32件</span>
                </p>
                <p>
                  <span class="month">06月</span>
                  <span class="event-item">发布“北斗高精度监控系统”</span>
                </p>
              </li>
              <li class="event" data-date="2020年">
                <p>
                  <span class="month">06月</span>
                  <span class="event-item">发布“钒星物联网系统”</span>
                </p>
                <p>
                  <span class="month">07月</span>
                  <span class="event-item">北斗三号全球组网成功</span>
                </p>
              </li>
              <li class="event" id="date" data-date="2019年">
                <p>
                  <span class="month">08月</span>
                  <span class="event-item">发布“天地卫通系统”</span>
                </p>
                <p>
                  <span class="month">12月</span>
                  <span class="event-item">被评为“高新技术企业”</span>
                </p>
              </li>

              <li class="event" data-date="2018年">
                <p>
                  <span class="month">03月</span>
                  <span class="event-item">建成北斗地面站和卫星数据中心</span>
                </p>
              </li>

              <li class="event" data-date="2017年">
                <p>
                  <span class="month">08月</span>
                  <span class="event-item">磐钴智能成立</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="tab" v-show="selectedIndex === 2">
        <div class="honor_wrapper">
          <div class="qualifications">
            <h3 class="content_wrapper">资质</h3>
            <div class="hornor_content content_wrapper">
              <div class="honor_item">
                <div class="img_wrapper">
                  <img src="../assets/about/1.webp" alt="广东省高新技术企业" />
                </div>
                <p>广东省高新技术企业</p>
              </div>

              <div class="honor_item">
                <div class="img_wrapper">
                  <img src="../assets/about/2.webp" alt="广东省守合同重信用企业" />
                </div>
                <p>广东省守合同重信用企业</p>
              </div>

              <div class="honor_item">
                <div class="img_wrapper">
                  <img src="../assets/about/3.webp" alt="广东省科技型中小企业" />
                </div>
                <p>广东省科技型中小企业</p>
              </div>

              <div class="honor_item">
                <div class="img_wrapper">
                  <img src="../assets/about/4.webp" alt="AAA级诚信供应商" />
                </div>
                <p>AAA级诚信供应商</p>
              </div>
              <div class="honor_item">
                <div class="img_wrapper">
                  <img src="../assets/about/5.webp" alt="AAA级质量服务诚信企业" />
                </div>
                <p>AAA级质量服务诚信企业</p>
              </div>

              <div class="honor_item">
                <div class="img_wrapper">
                  <img src="../assets/about/5.webp" alt="AAA级质量服务诚信企业" />
                </div>
                <p>AAA级质量服务诚信企业</p>
              </div>
              <div class="honor_item">
                <div class="img_wrapper">
                  <img src="../assets/about/6.webp" alt="AAA级诚信经营示范企业" />
                </div>
                <p>AAA级诚信经营示范企业</p>
              </div>
              <div class="honor_item">
                <div class="img_wrapper">
                  <img src="../assets/about/7.webp" alt="AAA级重合同守信用企业" />
                </div>
                <p>AAA级重合同守信用企业</p>
              </div>
            </div>
          </div>
          <div class="patent">
            <h3 class="content_wrapper">专利证书</h3>
            <div class="patent_content content_wrapper">
              <div class="hornor_content content_wrapper">
                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/8.webp" alt="实用新型专利证书-落水报警终端" />
                  </div>
                  <p>实用新型专利证书-落水报警终端</p>
                </div>

                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/9.webp" alt="实用新型专利证书-气象灾害预警" />
                  </div>
                  <p>实用新型专利证书-气象灾害预警</p>
                </div>

                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/10.webp" alt="实用新型专利证书-三模手持终端" />
                  </div>
                  <p>实用新型专利证书-三模手持终端</p>
                </div>

                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/11.webp" alt="实用新型专利证书-数传型通信终端" />
                  </div>
                  <p>实用新型专利证书-数传型通信终端</p>
                </div>
                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/12.webp" alt="外观设计专利证书-数传终端（北斗）" />
                  </div>
                  <p>外观设计专利证书-数传终端（北斗）</p>
                </div>

                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/13.webp" alt="实用新型专利证书-水利工程水情测量" />
                  </div>
                  <p>实用新型专利证书-水利工程水情测量</p>
                </div>
                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/14.webp" alt="发明专利证书-实现动态电子围栏放牧" />
                  </div>
                  <p>发明专利证书-实现动态电子围栏放牧</p>
                </div>
                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/15.webp" alt="发明专利证书-卫星高精度定位快速环境监测方法与设备" />
                  </div>
                  <p>发明专利证书-卫星高精度定位快速环境监测方法与设备</p>
                </div>
                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/16.webp" alt="实用新型专利证书-一种北斗地面站多通道北斗通讯的装置" />
                  </div>
                  <p>实用新型专利证书-一种北斗地面站多通道北斗通讯的装置</p>
                </div>
                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/17.webp" alt="实用新型专利证书-一种自供电低功耗北斗船舶示位终端" />
                  </div>
                  <p>实用新型专利证书-一种自供电低功耗北斗船舶示位终端</p>
                </div>
                <div class="honor_item">
                  <div class="img_wrapper">
                    <img src="../assets/about/19.webp" alt="实用新型专利证书-指挥型用户机" />
                  </div>
                  <p>实用新型专利证书-指挥型用户机</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab" v-show="selectedIndex === 3">
        <div class="news">
          <div v-for="item in newsData" :key="item.link" class="news_item content_wrapper">
            <p class="left_time">{{ item.day }}日</p>
            <div class="right_content">
              <p class="top_time">{{ item.month }}月 - {{ item.year }}年</p>
              <a class="news_content" :href="item.link" target="_blank">
                <h3>{{ item.title }}</h3>
                <p>{{ item.brief }}...</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="tab" v-show="selectedIndex === 4">
        <div class="contact content_wrapper">
          <div class="contact_content">
            <div class="contact_item">
              <h3>销售电话</h3>
              <div class="flex-start-align">
                <p>销售工程师：</p>
                <div>
                  <p>张<span style="margin-left: 1em;"></span>工 18988978129 应急、水利、风电</p>
                  <p>龚经理 18988974251 应急、水利、消防</p>
                  <p>张经理 18988972936 应急、水利、海洋</p>
                  <p>肖经理 18988974283 应急、电力</p>
                </div>
              </div>
              <div class="flex-start-align">
                <p>北斗卡办理：</p>
                <div>
                  <p>张<span style="margin-left: 1em;"></span>工 18988978129 </p>
                </div>
              </div>
              <div class="flex-start-align">
                <p>企事业合作：</p>
                <div>
                  <p>罗<span style="margin-left: 1em;"></span>工 18988978129 </p>
                </div>
              </div>
            </div>
            <div class="contact_item">
              <h3>固定电话</h3>
              <p>020-32379706</p>
            </div>
            <div class="contact_item">
              <h3>客服QQ</h3>
              <p>客服1：425530037</p>
              <p>客服2：466901251</p>
            </div>
            <div class="contact_item">
              <h3>公司地址</h3>
              <p>广州市黄埔区瑞和路39号纳金科技园G5座5楼</p>
            </div>
            <div class="contact_item">
              <h3>联系邮箱</h3>
              <p>open@pgiot.com</p>
            </div>
            <div class="contact_item">
              <h3>交通方式</h3>
              <p>公交站：575路、337路、359路、450路、 336路、338路（瑞和路口站）</p>
              <p>地铁站：广州地铁6号线香雪地铁站</p>
            </div>
          </div>
          <div class="partner">
            <h3>友情链接</h3>
            <div class="partner_wrapper">
              <div class="partner_item">
                <a href="https://www.sysu.edu.cn" target="_blank">中山大学</a>

                <a href="http://www.pgiot.com/" target="_blank">磐钴智能官网</a>

                <a href="http://www.fanxingiot.com/" target="_blank">钒星物联网</a>

                <a href="http://www.tiandiweitong.com/" target="_blank">天地卫通</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: '钒星北斗开放平台-卫星物联网',
  },
  data() {
    return {
      selectedIndex: 1,
      newsData: [
        {
          day: '09',
          month: '09',
          year: '2021',
          title: '基于北斗RDSS短报文的海洋浮标在线水质/气象综合监测系统',
          brief:
            '海洋观测浮标是自主研发的一款综合浮标，由硬件系统和软件系统组成，适用于水文观测、气象观测、水质监测等领域，可在恶劣环境实现无人值守的全天候连续观测。具备完整的水质监测系统',
          link: 'https://www.sohu.com/a/432188813_120089761',
        },
        {
          day: '16',
          month: '11',
          year: '2020',
          title: '基于北斗RDSS短报文卫星的物联网自动气象远程数据采集系统',
          brief:
            '北斗物联网监测是通过传感器、北斗系统等信息感知设备，按约定的协议连接起来，利用北斗RDSS短报文实现无距离限制的数据传输，数据监控，实时的采集和控制管理。可以监测多种要素气象的专业传感器，精度',
          link: 'https://www.sohu.com/a/432189968_120089761',
        },
        {
          day: '16',
          month: '11',
          year: '2020',
          title: '北斗卫星RDSS+物联网应用于水文水利自动水资源监测系统',
          brief:
            '数据传输通过北斗数传终端PD06或GPRS、3G、4G、LoRa等输出方式，将水文传感器参数数据传输到服务器端，水质监控中心实时监控水文变化，实时数据采集、传输、监控、管理和储存，预防事故等发生。它结合',
          link: 'https://www.sohu.com/a/432188418_120089761',
        },
        {
          day: '23',
          month: '07',
          year: '2020',
          title: '基于北斗RDSS短报文卫星的物联网自动气象远程数据采集系统',
          brief:
            '农业气象站进行农业环境实时监测，通过北斗卫星RDSS短报文终端PD06输出到服务器，运行状态监控、视频监控、站房状态监控、远程控制、远程操作等功能。用于农业环境的气象参数的监测，利用北斗RDSS短报',
          link: 'https://www.sohu.com/a/409102364_120089761',
        },
        {
          day: '04',
          month: '12',
          year: '2019',
          title: '喜讯！广州磐钴智能科技有限公司荣获高新技术企业认定',
          brief:
            '此次被评定为国家高新技术企业，是我司发展史上的又一个新的里程碑。今后的发展中，我司必将持续自主创新，加大研发投入，更加注重知识产权保护，培养高水平高素质的人才队伍，提升企业核心竞争力，力争成',
          link: 'https://www.sohu.com/a/358268316_120089761',
        },
        {
          day: '26',
          month: '11',
          year: '2019',
          title: '天地卫通位置监控平台开放免费申请，位置监控、轨迹回放、sos等功能可体验 ',
          brief:
            '公网状态下，企业账号可免费和app用户进行信息互通；绑定的用户开启自动上报位置后，企业账号可以随时随地查看绑定用户的位置信息、查看用户历史轨迹、处理用户报警信息、 查看用户报平安信息。 您可点击',
          link: 'https://www.sohu.com/a/356527352_120089761',
        },
        {
          day: '12',
          month: '08',
          year: '2019',
          title: '北斗RDSS卫星短报文通信对构建全国覆盖的应急通信链路的重要作用',
          brief:
            '基于北斗RDSS短报文通信卫星的位置追踪监控和应急通信系统技术解决方案，能够在广阔疆域里全天候、无缝隙、大范围地为用户确定其所在的地理经纬度，可为人员定位监控、车辆监控管理、船只指挥调度、安全',
          link: 'https://www.sohu.com/a/328446810_120089761',
        },
      ],
    };
  },
  methods: {
    selectTab(index) {
      this.selectedIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.about_wrapper {
  width: 100%;

  .bg {
    width: 100%;
    height: 300px;
    background: url('../assets/about/beijin.webp');
    position: relative;

    .tabs__header {
      box-sizing: border-box;
      width: 100%;
      height: 48px;
      position: absolute;
      bottom: 0;
      display: block;
      list-style: none;
      margin: 0;
      padding: 0;
      background: #ffffff;
      opacity: 0.7;
      text-align: center;

      li {
        padding: 15px 30px;
        margin: 0;
        display: inline-block;
        margin-right: 5px;
        cursor: pointer;

        .tab_item {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;

          span {
            margin-left: 10px;
          }

          svg {
            width: 18px;
            height: 18px;
            fill: currentColor;
          }
        }
      }

      .tab__selected {
        font-weight: bold;
        border-bottom: 2px solid #4173fb;
        color: #4173fb;
      }
    }
  }

  .about_content {
    width: 100%;

    .tab {
      display: inline-block;
      color: black;
      width: 100%;
    }

    .about_us {
      width: 100%;

      .intro {
        padding: 130px 0px;

        p {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 34px;
        }
      }

      .path {
        padding-top: 70px;
        // width: 100%;
        background: #f6f7f8;
        padding-bottom: 70px;

        h1 {
          font-size: 28px;
          font-weight: 400;
          color: #0d0e24;
          text-align: center;
        }

        .timeline {
          border-left: 1px solid #e9e9e9;
          margin: 50px auto;
          letter-spacing: 0.5px;
          position: relative;
          line-height: 1.4em;
          padding: 0px 0px 0px 70px;
          list-style: none;
          text-align: left;
          font-weight: 100;
          // max-width: 40%;
          width: 720px;

          .event {
            border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
            padding-bottom: 25px;
            margin-bottom: 50px;
            position: relative;

            p {
              margin-top: 30px;

              .month {
                font-size: 18px;
                font-weight: 400;
                color: #0d0e24;
                margin-right: 30px;
              }

              .event-item {
                font-size: 14px;
                font-weight: 300;
                color: #6e6e66;
              }
            }

            &:before {
              position: absolute;
              display: block;
              top: 0;
              left: -235.5px;
              font-weight: 400;
              color: #0d0e24;
              content: attr(data-date);
              text-align: right;
              font-size: 20px;
              min-width: 120px;
            }

            &:after {
              position: absolute;
              display: block;
              left: -77.65px;
              content: '';
              top: 3px;
              width: 0;
              height: 0;
              border-bottom: 16px solid #4d72f2;
              border-right: 8px solid transparent;
              border-left: 8px solid transparent;
            }
          }
        }
      }
    }

    .honor_wrapper {
      width: 100%;
      margin-top: 60px;

      .qualifications {
        width: 100%;
        background-color: #fff;

        h3 {
          font-size: 20px;
          font-weight: 400;
          color: #0d0e24;
          margin-bottom: 36px;
        }
      }

      .patent {
        width: 100%;
        background-color: #f6f7f8;
        padding-top: 60px;
        padding-bottom: 60px;

        h3 {
          font-size: 20px;
          font-weight: 400;
          color: #0d0e24;
          margin-bottom: 36px;
        }
      }

      .hornor_content {
        display: grid;
        grid-template-columns: 22% 22% 22% 22%;
        grid-row-gap: 50px;
        grid-column-gap: 4%;
        margin-bottom: 36px;

        .honor_item {
          box-sizing: border-box;
          padding: 15px;
          border: 1px solid #eeeeee;

          .img_wrapper {
            height: 222px;
            background-color: #fafbff;
            position: relative;

            img {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          p {
            text-align: center;
            font-size: 14px;
            font-weight: 300;
            color: #0d0e24;
            margin-top: 24px;
          }
        }
      }
    }

    .news {
      margin-bottom: 70px;

      .news_item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        padding: 30px;
        background-color: rgba(255, 255, 255);
        box-shadow: 0px 4px 14px 0px rgba(47, 84, 215, 0.05);
        margin-top: 10px;

        .left_time {
          padding-top: 10px;
          padding-right: 30px;
          font-size: 24px;
          font-weight: 400;
          color: #0d0e24;
          white-space: nowrap;
        }

        .right_content {
          .top_time {
            font-size: 14px;
            font-weight: 300;
            color: #6e6e66;
            padding-bottom: 10px;
            border-bottom: 1px solid #dedede;
          }

          .news_content {
            margin-top: 20px;
            display: inline-block;
            text-decoration: none;

            h3 {
              font-size: 16px;
              font-weight: 400;
              color: #0d0e24;
            }

            p {
              margin-top: 20px;
              font-size: 14px;
              font-weight: 300;
              color: #6e6e66;
            }
          }
        }

        &:hover {
          background-color: rgba(243, 243, 243, 0.5);
        }
      }
    }

    .contact {
      .contact_content {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        .contact_item {
          padding: 66px 0;
          width: 33.33%;
          box-sizing: border-box;

          h3 {
            font-size: 20px;
            font-weight: 400;
            color: #0d0e24;
            margin-bottom: 30px;
          }

          p {
            font-size: 14px;
            font-weight: 300;
            color: #6e6e66;
            margin-bottom: 10px;
          }
        }
      }

      .partner {
        padding-left: 54px;
        padding-top: 66px;
        margin-bottom: 100px;

        h3 {
          font-size: 20px;
          font-weight: 400;
          color: #0d0e24;
        }

        .partner_wrapper {
          width: 100%;
          margin-top: 16px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;

          a {
            font-size: 16px;
            font-weight: 300;
            color: #4173fb;
            text-decoration: none;
            margin-right: 116px;
          }
        }
      }
    }
  }
}
</style>